import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-foreground-950 text-white rounded-2xl mx-4 md:mx-6 mb-6 mt-0 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl md:text-4xl text-white leading-tight mb-3">Stay Updated</h3>
            <p className="text-white/50 text-sm leading-relaxed mb-8 max-w-sm">
              Get the latest pandabuy spreadsheet updates, new category additions, and trending finds delivered straight to your inbox.
            </p>
            <form onSubmit={handleSubscribe} className="max-w-sm">
              <div className="relative mb-4">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="w-full bg-transparent border-b border-white/20 pb-2 text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-white/50 transition-colors"
                />
              </div>
              <div className="website-alt-wrapper" aria-hidden="true">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" />
              </div>
              <button
                type="submit"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-foreground-950 text-sm font-medium hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
              >
                {submitted ? 'Subscribed!' : 'Subscribe'}
                <i className={`text-sm ${submitted ? 'ri-check-line' : 'ri-arrow-right-line'}`}></i>
              </button>
              {submitted && (
                <p className="text-xs text-accent-400 mt-2">Thanks for subscribing! We will keep you posted.</p>
              )}
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Navigate</h4>
            <div className="flex flex-col gap-3">
              <a href="#categories" className="text-sm text-white/50 hover:text-white transition-colors underline decoration-white/15 hover:decoration-white/50 whitespace-nowrap cursor-pointer">Categories</a>
              <a href="#about" className="text-sm text-white/50 hover:text-white transition-colors underline decoration-white/15 hover:decoration-white/50 whitespace-nowrap cursor-pointer">About pandabuyspreadsheet</a>
              <Link to="/article/pandabuy-spreadsheet-beginners" className="text-sm text-white/50 hover:text-white transition-colors underline decoration-white/15 hover:decoration-white/50 whitespace-nowrap cursor-pointer">Beginners Guide 2026</Link>
              <a href="#features" className="text-sm text-white/50 hover:text-white transition-colors underline decoration-white/15 hover:decoration-white/50 whitespace-nowrap cursor-pointer">Features</a>
              <a href="#reviews" className="text-sm text-white/50 hover:text-white transition-colors underline decoration-white/15 hover:decoration-white/50 whitespace-nowrap cursor-pointer">Reviews</a>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Quick Categories</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/50 hover:text-white transition-colors underline decoration-white/15 hover:decoration-white/50 whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/40 hover:text-white/70 text-sm underline decoration-white/15 hover:decoration-white/40 whitespace-nowrap cursor-pointer">Twitter</a>
            <a href="#" className="text-white/40 hover:text-white/70 text-sm underline decoration-white/15 hover:decoration-white/40 whitespace-nowrap cursor-pointer">Discord</a>
            <a href="#" className="text-white/40 hover:text-white/70 text-sm underline decoration-white/15 hover:decoration-white/40 whitespace-nowrap cursor-pointer">Reddit</a>
          </div>
          <p className="text-white/30 text-xs text-center">
            &copy; 2026 pandabuy.monster. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/30 hover:text-white/50 text-xs underline decoration-white/10 hover:decoration-white/30 whitespace-nowrap cursor-pointer">Disclaimer</a>
            <a href="#" className="text-white/30 hover:text-white/50 text-xs underline decoration-white/10 hover:decoration-white/30 whitespace-nowrap cursor-pointer">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}